module.exports = __webpack_public_path__ + "static/media/7-Hearts.0f1494e6.svg";